import { z } from 'zod'

export const column = z.object({
    id: z.string(),
    name: z.string(),
})

export type Column = z.infer<typeof column>
